import { Dispatch }                 from "redux";
import Account                      from "../../../domain/account/Account";
import AccountOptionTypes           from "../../../domain/account/AccountOptionTypes";
import AccountPlanTypeClass         from "../../../domain/account/AccountPlanTypeClass";
import AccountRepository            from "../../../domain/account/AccountRepository";
import AccountRoleTypeClass         from "../../../domain/account/AccountRoleTypeClass";
import { AuthenticationRepository } from "../../../domain/authentication/AuthenticationRepository";
import AccountDataSource            from "../../../infrastructure/datasource/account/AccountDataSource";
import AuthenticationDataSource     from "../../../infrastructure/datasource/authentication/AuthenticationDataSource";

export default class GetAccount {
  constructor(
    private readonly dispatch: Dispatch,
    private readonly authenticationRepository: AuthenticationRepository = new AuthenticationDataSource(),
    private readonly accountRepository: AccountRepository = new AccountDataSource(dispatch),
  ) {
  }

  public async execute() {
    const response = await this.authenticationRepository.getAccount();
    const data = response.data;
    const account: Account = new Account(
      new AccountRoleTypeClass(data.role),
      new AccountPlanTypeClass(data.plan),
      new AccountOptionTypes(data.options)
    );
    this.accountRepository.store(account);
  }
}